export const setStateCheckEst = (ischecked=false) => {
    return {
        type : 'SET_STATE_CHECK_EST',
        payload : ischecked
    }
}


